module.exports = __webpack_public_path__ + "static/360logo-5b00c6213bd0a50e79369ec99477aa1b.webp";